<div class="container-fluid" style="height: 100%">
  <div class="row">
    <div class="col-12 py-2-vw modelHeader d-flex justify-content-between">
      <div class="px-2-vw w-100">
        <p
          class="blueColoredText fw-600 fs-16-vw mb-3-vw"
          [ngClass]="{
            'd-flex justify-content-between align-items-center':
              modelData?.button?.isCloseBtn
          }"
        >
          <ng-container *ngIf="modelData?.button?.isDelete">
            <img src="../../../../assets/images/delete_icon4.png" alt="" />
            &nbsp;
          </ng-container>
          <ng-container *ngIf="data.icon">
            <i [class]="data.icon"></i>
            &nbsp;
          </ng-container>

          {{ modelData.header }}
          <ng-container *ngIf="modelData?.button?.isCloseBtn">
            <img
              class="cursor closeIcon"
              (click)="closeModel('')"
              src="../../../../assets/images/blue_close_icon.png"
              alt=""
            />
          </ng-container>
        </p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 px-4-vw">
      <div
        *ngIf="modelData?.isSuccess"
        class="success-icon d-flex justify-content-center"
      >
        <div class="checkmark-circle">
          <span class="checkmark"></span>
        </div>
      </div>
      <p
        class="fw-500 blueColoredText fs-13-vw mb-3-vw"
        [ngClass]="[
          modelData?.data?.style?.bodyFont
            ? modelData?.data?.style?.bodyFont
            : 'fs-13-vw',
          modelData?.data?.style?.bodyWeight
            ? modelData?.data?.style?.bodyWeight
            : 'fw-500'
        ]"
      >
        {{ modelData.data?.bodyData }}
      </p>
    </div>
  </div>

  <!-- <mat-dialog-actions align="end" class="mb-1-vw"> -->
  <div
    class="col-12 d-flex align-items-end mb-3-vw mt-2-vw"
    [ngClass]="
      modelData?.button?.isSingleButton
        ? 'justify-content-center'
        : 'justify-content-end'
    "
  >
    <button
      *ngIf="
        !modelData?.button?.isDiscard &&
        !modelData?.button?.isCancel &&
        modelData?.button?.isCloseText &&
        !modelData?.button?.hideAllButtonsLeftSubmit
      "
      type="button"
      id="cancelModalButton"
      class="btn secondaryButton rounded me-3-vw fs-16-vw"
      (click)="closeModel('close')"
    >
      {{ modelData?.button?.closeButtonText }}
    </button>
    <button
      *ngIf="
        !modelData?.button?.isDiscard &&
        !modelData?.button?.isCloseText &&
        !modelData?.button?.hideAllButtonsLeftSubmit
      "
      type="button"
      id="cancelModalButton"
      class="btn secondaryButton rounded me-3-vw fs-16-vw"
      (click)="closeModel('close')"
    >
      Cancel
    </button>
    <button
      *ngIf="
        modelData?.button?.isDiscard &&
        !modelData?.button?.hideAllButtonsLeftSubmit
      "
      type="button"
      id="cancelModalButton"
      class="btn secondaryButton rounded me-3-vw fs-16-vw"
      (click)="closeModel('close')"
    >
      Discard
    </button>
    <button
      *ngIf="modelData?.button?.isSubmit"
      type="button"
      id="saveModalButton"
      class="btn primaryButton fs-16-vw"
      (click)="closeModel('ok')"
    >
      {{ submitbtnTxt }}
    </button>
    <button
      *ngIf="
        modelData?.button?.isDelete &&
        !modelData?.button?.hideAllButtonsLeftSubmit
      "
      type="button"
      id="saveModalButton"
      class="btn primaryButton"
      (click)="closeModel('ok')"
    >
      Delete
    </button>
  </div>
</div>
